import React, { useEffect, useMemo, useRef, useState } from "react";

import { fetchMentionableUsersApi } from "../../../../services/moduleContentQuestionNotificationsApi";

const getMentionQuery = (value, cursor) => {
    const beforeCursor = value.slice(0, cursor);
    const match = beforeCursor.match(/@([\p{L}\p{N}._%+-]{0,40})$/u);
    return match ? match[1] : null;
};

export default function MentionAutocomplete({
    moduleId,
    value,
    onChange,
    placeholder,
    required,
    className = "cq-textarea",
}) {
    const textareaRef = useRef(null);
    const [cursor, setCursor] = useState(0);
    const [query, setQuery] = useState(null);
    const [users, setUsers] = useState([]);

    const active = query !== null && moduleId;

    useEffect(() => {
        if (!active) {
            setUsers([]);
            return;
        }
        let cancelled = false;
        const timer = setTimeout(async () => {
            try {
                const response = await fetchMentionableUsersApi(moduleId, query);
                if (!cancelled) setUsers(response.data || []);
            } catch {
                if (!cancelled) setUsers([]);
            }
        }, 180);
        return () => {
            cancelled = true;
            clearTimeout(timer);
        };
    }, [active, moduleId, query]);

    const updateCursor = (target) => {
        const nextCursor = target.selectionStart || 0;
        setCursor(nextCursor);
        setQuery(getMentionQuery(target.value, nextCursor));
    };

    const handleChange = (event) => {
        onChange?.(event.target.value);
        updateCursor(event.target);
    };

    const chooseUser = (user) => {
        const mentionQuery = getMentionQuery(value, cursor);
        if (mentionQuery === null) return;
        const mentionStart = cursor - mentionQuery.length - 1;
        const token = `@${user.mentionToken || user.username || user.email} `;
        const nextValue = `${value.slice(0, mentionStart)}${token}${value.slice(cursor)}`;
        onChange?.(nextValue);
        setQuery(null);
        setUsers([]);
        requestAnimationFrame(() => {
            const nextCursor = mentionStart + token.length;
            textareaRef.current?.focus();
            textareaRef.current?.setSelectionRange(nextCursor, nextCursor);
            setCursor(nextCursor);
        });
    };

    const visibleUsers = useMemo(() => users.slice(0, 6), [users]);

    return (
        <div className="cq-mention-wrap">
            <textarea
                ref={textareaRef}
                className={className}
                value={value}
                onChange={handleChange}
                onClick={(event) => updateCursor(event.target)}
                onKeyUp={(event) => updateCursor(event.target)}
                placeholder={placeholder}
                required={required}
            />
            {active && visibleUsers.length > 0 ? (
                <div className="cq-mention-menu">
                    {visibleUsers.map((user) => (
                        <button type="button" key={user.id} onMouseDown={(event) => event.preventDefault()} onClick={() => chooseUser(user)}>
                            <span>{user.fullName || user.email || "Utilisateur"}</span>
                            <small>{user.email}</small>
                        </button>
                    ))}
                </div>
            ) : null}
        </div>
    );
}
